import React from 'react';
import { FiArrowDownRight } from 'react-icons/fi';
import { HiOutlineSparkles } from 'react-icons/hi2';
import Header from './Header';
import ProfileImg from '../assets/img/profile-img.webp';
import FadeUpTitle from './FadeUpTitle';
import { useTranslate } from 'react-translate';

const Hero = () => {
  const t = useTranslate('Hero');

  const scrollToSection = () => {
    document.getElementById('projects').scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <section className='relative overflow-hidden pb-16 pt-2 md:pb-24'>
      <div className='grid-lines'></div>
      <div className='orb orb-a'></div>
      <div className='orb orb-b'></div>

      <Header />

      <div className='section-shell relative z-[2] pt-14 md:pt-20'>
        <div className='mx-auto flex max-w-3xl flex-col items-center text-center'>
          <div
            className='section-kicker'
            data-aos='fade-up'
            data-aos-delay='50'
          >
            <HiOutlineSparkles className='text-base' />
            {t('role')}
          </div>

          <div data-aos='fade-up' data-aos-delay='100' className='flex justify-center'>
            <FadeUpTitle text={t('title')} />
          </div>

          <p
            className='section-copy mt-6 max-w-xl text-lg'
            data-aos='fade-up'
            data-aos-delay='150'
          >
            {t('greeting')}
          </p>

          <div
            className='mt-8 flex flex-wrap items-center justify-center gap-4'
            data-aos='fade-up'
            data-aos-delay='200'
          >
            <button
              type='button'
              onClick={scrollToSection}
              className='primary-link'
            >
              {`${t('button')}${t('button_two')}${t('button_three')}`}
              <FiArrowDownRight className='text-lg' />
            </button>
            <a href='mailto:raul@raulwebdev.com' className='secondary-link'>
              raul@raulwebdev.com
            </a>
          </div>
        </div>

        <div
          className='relative mx-auto mt-14 flex justify-center'
          style={{ width: 'fit-content' }}
          data-aos='zoom-in'
          data-aos-delay='150'
        >
          <div className='portrait-ring'>
            <div className='portrait-inner'>
              <img src={ProfileImg} alt='Raul' />
            </div>
          </div>
          <div
            className='float-badge'
            style={{ top: '20px', left: '-70px' }}
          >
            <svg viewBox='0 0 24 24' fill='none' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              <rect x='7' y='2' width='10' height='20' rx='2.5'></rect>
            </svg>
            SwiftUI
          </div>
          <div
            className='float-badge'
            style={{ bottom: '10px', right: '-90px' }}
          >
            <svg viewBox='0 0 24 24' fill='none' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              <path d='M4 9l8-5 8 5-8 5-8-5Z'></path>
              <path d='M4 14l8 5 8-5'></path>
            </svg>
            React &amp; Node
          </div>
        </div>

        <div
          className='hero-stats relative z-[1] mt-14'
          data-aos='fade-up'
          data-aos-delay='250'
        >
          <div className='hero-stat'>
            <div className='hero-stat-num'>5+</div>
            <div className='hero-stat-label'>{t('stat_years')}</div>
          </div>
          <div className='hero-stat'>
            <div className='hero-stat-num'>{t('stat_stack_title')}</div>
            <div className='hero-stat-label'>{t('stat_stack_copy')}</div>
          </div>
          <div className='hero-stat'>
            <div className='hero-stat-num'>iOS</div>
            <div className='hero-stat-label'>{t('stat_ios_copy')}</div>
          </div>
          <div className='hero-stat flex items-center'>
            <span className='mr-2 h-2 w-2 flex-shrink-0 rounded-full' style={{ background: 'var(--indigo)' }}></span>
            <span className='hero-stat-num'>{t('location_label')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
